import storage from './storage';

const ANONYMOUS_ID_STORAGE_KEY = 'pendoAnonymousId';

// Pendo docs: https://support.pendo.io/hc/en-us/articles/360031862272-Install-Pendo-on-a-single-page-web-application
// @ts-ignore
const getPendoFromWindow = () => window.pendo;

const getOrGenerateAnonymousId = () => {
    const existingAnonymousId = storage.loadState(ANONYMOUS_ID_STORAGE_KEY, true) as string;
    if (existingAnonymousId) {
        return existingAnonymousId;
    }
    const newAnonymousId = crypto.randomUUID();
    storage.saveState(ANONYMOUS_ID_STORAGE_KEY, newAnonymousId, true);
    return newAnonymousId;
};

const trackEvent = (
    visitor: { [attr: string]: string },
    event: string,
    eventAttributes?: { [attr: string]: string }
) => {
    const pendo = getPendoFromWindow();
    withSilentFailure(() => {
        if (pendo.isReady && pendo.isReady()) {
            pendo.identify({ visitor });
        } else {
            pendo.initialize({ visitor });
        }
        pendo.track(event, eventAttributes);
    });
};

const buildAnonymousVisitor = (props?: { [attr: string]: string }) => ({ id: getOrGenerateAnonymousId(), ...props });

const withSilentFailure = (pendoCall: () => void) => {
    try {
        pendoCall();
    } catch (err) {
        // Silently fail on any pendo actions
        console.error(err);
    }
};

export default {
    getOrGenerateAnonymousId,
    trackEvent,
    buildAnonymousVisitor,
};
